import { render, staticRenderFns } from "./luckdraw_new.vue?vue&type=template&id=c2add714&scoped=true&"
import script from "./luckdraw_new.vue?vue&type=script&lang=js&"
export * from "./luckdraw_new.vue?vue&type=script&lang=js&"
import style0 from "./luckdraw_new.vue?vue&type=style&index=0&id=c2add714&scoped=true&lang=css&"
import style1 from "./luckdraw_new.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2add714",
  null
  
)

export default component.exports